import { useEffect } from 'react';
import { formEventV2 } from '../service/formEventV2';

/**
 * icon 展示时上报 float_ad_view，并清除 sessionStorage _cartsee_pop_show（避免其他请求误判当前弹窗在展示）
 */
export function useIconShowTracking(options: {
  /** 悬浮 icon 是否展示 */
  iconShow: boolean;
  triggerEventType: number;
  id: string;
  name: string;
}) {
  const { iconShow, triggerEventType, id, name } = options;

  useEffect(() => {
    if (!iconShow) return;
    /** 当前无弹窗展示，仅 icon 展示，清除占位 */
    sessionStorage?.removeItem('_cartsee_pop_show');
    formEventV2({
      event: 'float_ad_view',
      triggerEventType,
      formId: id,
      formName: name
    }).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iconShow]);
}
